'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_AuditView$$anon$5() {
  this.aBF = null;
  this.aBG = false;
}
export { $c_Lpresto_AuditView$$anon$5 as $c_Lpresto_AuditView$$anon$5 };
$p = $c_Lpresto_AuditView$$anon$5.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AuditView$$anon$5;
/** @constructor */
function $h_Lpresto_AuditView$$anon$5() {
}
export { $h_Lpresto_AuditView$$anon$5 as $h_Lpresto_AuditView$$anon$5 };
$h_Lpresto_AuditView$$anon$5.prototype = $p;
$p.P = (function() {
  if ((!this.aBG)) {
    this.aBF = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T2($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.aBG = true;
  }
  return this.aBF;
});
var $d_Lpresto_AuditView$$anon$5 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AuditView$$anon$5, "presto.AuditView$$anon$5", ({
  EB: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_AuditView$$anon$5 as $d_Lpresto_AuditView$$anon$5 };
//# sourceMappingURL=presto.-Audit-View$$anon$5.js.map
